(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {

  /*
   * ==========================================
   * GET SIZE OPTION
   * ==========================================
   */

  function findSizeOption() {

    var variantPicker =
      document.querySelector('variant-picker');

    if (!variantPicker) {
      return null;
    }


    var options =
      variantPicker.querySelectorAll(
        '.variant-option'
      );


    var sizeOption = null;


    options.forEach(function (option) {

      var legend =
        option.querySelector('legend');


      if (!legend) {
        return;
      }


      var optionName =
        legend.textContent
          .trim()
          .toLowerCase();


      if (
        optionName === 'size' ||
        optionName.startsWith('size ')
      ) {
        sizeOption = option;
      }

    });


    return sizeOption;

  }


  /*
   * ==========================================
   * CREATE SIZE CHART BUTTON
   * ==========================================
   *
   * IMPORTANT:
   *
   * We DO NOT move the original button.
   *
   * We create a new button after the Size
   * option.
   *
   * Therefore Shopify can re-render the
   * variant picker without destroying the
   * original Size Chart modal.
   */

  function insertSizeChartButton() {

    var source =
      document.querySelector(
        '[data-size-chart-source]'
      );


    if (!source) {
      return;
    }


    var sourceButton =
      source.querySelector(
        '[data-size-chart-open]'
      );


    if (!sourceButton) {
      return;
    }


    var sizeOption =
      findSizeOption();


    if (!sizeOption) {
      return;
    }


    /*
     * Check whether our button already exists.
     */

    var existingButton =
      sizeOption.nextElementSibling;


    if (
      existingButton &&
      existingButton.hasAttribute(
        'data-size-chart-clone'
      )
    ) {
      return;
    }


    /*
     * Remove an old clone if Shopify has
     * changed the structure.
     */

    var oldClone =
      sizeOption.parentElement.querySelector(
        '[data-size-chart-clone]'
      );


    if (oldClone) {
      oldClone.remove();
    }


    /*
     * Create wrapper.
     */

    var wrapper =
      document.createElement('div');


    wrapper.className =
      'ila-size-chart-wrapper';


    wrapper.setAttribute(
      'data-size-chart-clone',
      'true'
    );


    /*
     * Create button.
     */

    var button =
      document.createElement('button');


    button.type = 'button';

    button.className =
      'ila-size-chart-button';


    button.setAttribute(
      'aria-haspopup',
      'dialog'
    );


    button.setAttribute(
      'aria-controls',
      sourceButton.getAttribute(
        'aria-controls'
      )
    );


    button.setAttribute(
      'data-size-chart-open',
      'true'
    );


    /*
     * Copy the button text.
     */

    var text =
      document.createElement('span');


    text.textContent =
      sourceButton.textContent.trim();


    button.appendChild(text);

    wrapper.appendChild(button);


    /*
     * Put Size Chart immediately after Size.
     */

    sizeOption.insertAdjacentElement(
      'afterend',
      wrapper
    );

  }


  /*
   * ==========================================
   * MODAL
   * ==========================================
   */

  function openSizeChart(button) {

    var modalId =
      button.getAttribute(
        'aria-controls'
      );


    var modal =
      document.getElementById(modalId);


    if (!modal) {
      return;
    }


    modal.hidden = false;


    document.body.classList.add(
      'ila-size-chart-open'
    );


    setTimeout(function () {

      var closeButton =
        modal.querySelector(
          '.ila-size-chart-close'
        );


      if (closeButton) {
        closeButton.focus();
      }

    }, 50);

  }


  function closeSizeChart(modal) {

    if (!modal) {
      return;
    }


    modal.hidden = true;


    document.body.classList.remove(
      'ila-size-chart-open'
    );

  }


  /*
   * ==========================================
   * CLICK HANDLER
   * ==========================================
   *
   * Event delegation means this also works
   * for buttons created after Shopify
   * re-renders the variant picker.
   */

  document.addEventListener(
    'click',
    function (event) {

      /*
       * Size Chart button
       */

      var openButton =
        event.target.closest(
          '[data-size-chart-open]'
        );


      if (openButton) {

        event.preventDefault();

        openSizeChart(openButton);

        return;

      }


      /*
       * Close button / overlay
       */

      var closeButton =
        event.target.closest(
          '[data-size-chart-close]'
        );


      if (closeButton) {

        event.preventDefault();

        var modal =
          closeButton.closest(
            '[data-size-chart-modal]'
          );


        closeSizeChart(modal);

      }

    }
  );


  /*
   * ==========================================
   * ESC KEY
   * ==========================================
   */

  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key !== 'Escape') {
        return;
      }


      var openModal =
        document.querySelector(
          '[data-size-chart-modal]:not([hidden])'
        );


      if (openModal) {
        closeSizeChart(openModal);
      }

    }
  );


  /*
   * ==========================================
   * INITIAL LOAD
   * ==========================================
   */

  insertSizeChartButton();


  /*
   * ==========================================
   * SHOPIFY THEME EDITOR
   * ==========================================
   */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(function () {
        insertSizeChartButton();
      }, 100);

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function () {

      setTimeout(function () {
        insertSizeChartButton();
      }, 100);

    }
  );


  /*
   * ==========================================
   * WATCH VARIANT PICKER
   * ==========================================
   *
   * Whenever Size/Color is changed Shopify
   * may rebuild the variant options.
   *
   * We simply recreate the Size Chart button
   * after the Size option.
   */

  function observeVariantPicker() {

    var variantPickers =
      document.querySelectorAll(
        'variant-picker'
      );


    variantPickers.forEach(
      function (variantPicker) {

        if (
          variantPicker.dataset
            .ilaSizeChartObserver === 'true'
        ) {
          return;
        }


        variantPicker.dataset
          .ilaSizeChartObserver = 'true';


        var observer =
          new MutationObserver(
            function () {

              insertSizeChartButton();

            }
          );


        observer.observe(
          variantPicker,
          {
            childList: true,
            subtree: true
          }
        );

      }
    );

  }


  observeVariantPicker();


  /*
   * Extra check after Shopify finishes
   * rendering the product page.
   */

  setTimeout(function () {

    insertSizeChartButton();

    observeVariantPicker();

  }, 300);


  setTimeout(function () {

    insertSizeChartButton();

  }, 1000);


})();
  } catch(e) { console.error(e); }
})();

})();
